<template>
  <div>
    <template v-if="styleType === 'for-kiko'">
      <CouponKiko v-bind="$attrs" v-on="$listeners"></CouponKiko>
    </template>
    <template v-else-if="styleType === 'for-joychat'">
      <CouponJoychat v-bind="$attrs" v-on="$listeners"></CouponJoychat>
    </template>
    <template v-else-if="styleType === 'for-echo'">
      <CouponEcho v-bind="$attrs" v-on="$listeners"></CouponEcho>
    </template>
    <template v-else>
      <CouponVava v-bind="$attrs" v-on="$listeners"></CouponVava>
    </template>
  </div>
</template>

<script>
import CouponVava from './CouponVava.vue'
import CouponEcho from './CouponEcho.vue'
import CouponJoychat from './CouponJoychat.vue'
import CouponKiko from './CouponKiko.vue'

export default {
  inheritAttrs: false,
  components: { CouponVava, CouponEcho, CouponJoychat, CouponKiko },
  props: {
    styleType: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="less" scoped></style>
